$(document).ready(function () {
  $("body")
    .on("mouseenter click", ".work_mega_menu", function () {
      var $t = $(this);
      var lnk = $t.children('a');
      var sub = lnk.next();
      $t.addClass("active").attr("aria-expanded", "true");
      sub.show();
    })
    .on("mouseleave", ".work_mega_menu", function () {
      var $t = $(this);
      var lnk = $t.children('a');
      var sub = lnk.next();
      $t.removeClass("active").attr("aria-expanded", "false");
      sub.hide();
    });
});
